module.exports = __webpack_public_path__ + "img/mobile_video_background.66bd6a09.png";